(() => {
  if (customElements.get("ab-low-stock")) return;

  class AbLowStock extends HTMLElement {
    connectedCallback() {
      this.container = this.closest("[data-section-type]");
      this.textEl = this.querySelector("[data-low-stock-text]");
      const json = this.querySelector("[data-low-stock-json]");
      if (!this.container || !this.textEl || !json) return;

      try {
        this.counts = JSON.parse(json.textContent);
      } catch (error) {
        return;
      }

      this.variantIds = new Set(
        (this.dataset.variantIds || "").split(",").filter(Boolean),
      );
      this.onVariantChange = (event) =>
        this.update(event.detail && event.detail.variant);
      this.container.addEventListener(
        "theme:variant:change",
        this.onVariantChange,
      );
    }

    disconnectedCallback() {
      if (!this.container || !this.onVariantChange) return;
      this.container.removeEventListener(
        "theme:variant:change",
        this.onVariantChange,
      );
    }

    update(variant) {
      // Quick add windows opened on this page fire the same event for other products.
      if (variant && !this.variantIds.has(String(variant.id))) return;

      const count = variant && variant.available ? this.counts[variant.id] : 0;
      if (!count) {
        this.dataset.state = "none";
        this.textEl.textContent = "";
        return;
      }

      this.textEl.textContent = (this.dataset.text || "")
        .replaceAll("[count]", count)
        .replaceAll("[variant]", variant.title || "")
        .replaceAll("[option1]", variant.option1 || "")
        .replaceAll("[option2]", variant.option2 || "")
        .replaceAll("[option3]", variant.option3 || "");
      this.dataset.state = "low";
    }
  }

  customElements.define("ab-low-stock", AbLowStock);
})();
